import * as React from 'react';
import styled from 'styled-components';

interface IState {
  hover: boolean;
}

export interface IPropsAutoCompleteOption {
  optionList: Array<any>;
  nameAsValue: boolean;
  focus: boolean;
  themeColor: string;
  label: string | number;
  value: string | number;
  onClick: any;
  selected: boolean;
}

const StyledAutoCompleteOption = styled.li<{
  hover: boolean;
  themeColor: string;
  selected: boolean;
}>
`
  background-color: ${props => {
    if (props.hover || props.selected)
      return props.theme[props.themeColor];
    else
      return 'white';
  }};
  color: ${props => {
    if (props.hover || props.selected)
      return 'white';
    else
      return 'black';
  }};
  cursor: pointer;
  padding: 0 4px;
`;
export class AutoCompleteOption extends React.Component<Partial<IPropsAutoCompleteOption>, IState> {
  constructor(props: IPropsAutoCompleteOption) {
    super(props);
    this.state = {
      hover: false
    };
  }
  mouseHover = () => {
    this.setState({ hover: true });
  }
  mouseOut = () => {
    this.setState({ hover: false });
  }

  render() {
    return (
      <StyledAutoCompleteOption
        onMouseOver={this.mouseHover}
        onMouseOut={this.mouseOut}
        onMouseDown={this.props.onClick}
        hover={this.state.hover}
        themeColor={this.props.themeColor ? this.props.themeColor : 'primaryColor'}
        value={this.props.value}
        selected={Boolean(this.props.selected)}
      >
        {this.props.label}
      </StyledAutoCompleteOption>
    );
  }
}
